<template>
    <div>
        <nav-bar :info="info" :notifications="notifications"/>
        <router-view :info="info" :notifications="notifications" :key="$route.fullPath"/>
        <error-messages />
        <page-footer/>
        <unauthorised-modal v-if="unauthorised"/>
    </div>
</template>

<script>
    import NavBar from '~/components/Shared/Partials/NavBar';
    import PageFooter from '~/components/Shared/Partials/Footer';
    import UnauthorisedModal from "../components/Shared/UIComponents/UnauthorisedModal";

    export default {
        components: {
            NavBar,
            PageFooter,
            UnauthorisedModal
        },
        data() {
            return {
                unauthorised: false,
            };
        },
        props: ['info', 'notifications'],
        created() {
            this.$eventBus.$on('unauthorised', (unauthorised) => {
                this.unauthorised = unauthorised;
            });
        }
    }
</script>
